import { createQueryKey } from '../../query/createQueryKeyFactory';
import { QueryKeyParam } from '../../query/types';

/** Query keys for ['store', scopedId, categories, *] */
const categoryKeys = (scopeId: QueryKeyParam) =>
  createQueryKey({
    all: ['store', scopeId, 'categories'] as const,
    allIncludingUnused: ['store', scopeId, 'categories', 'allIncludingUnused'] as const,
    id: (id) =>
      createQueryKey({
        all: ['store', scopeId, 'categories', id] as const,
        detail: ['store', scopeId, 'categories', id, 'detail'] as const,
      }),
  });

export { categoryKeys };
